import type { ReactElement } from 'react';

import {
  BpkExtraLargeSpinner,
  SPINNER_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-spinner';
import classNames from 'classnames';

import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

import STYLES from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = {
  spinnerClassName?: string;
  spinnerType?: Values<typeof SPINNER_TYPES>;
};

export const LoadingSpinner = ({
  spinnerClassName = '',
  spinnerType = SPINNER_TYPES.primary,
}: LoadingSpinnerProps = {}): ReactElement => (
  <div className={classNames(STYLES.spinnerWrapper, spinnerClassName)}>
    <BpkExtraLargeSpinner type={spinnerType} />
  </div>
);
